

  <div class="carousel-container">
  <div class="carousel-content">
    <div class="carousel-title">{{ images[selectedIndex].title }}</div>
    <div class="carousel-images">
      <img
        *ngFor="let image of images; let i = index"
        [src]="image.src"
        alt="Image slide"
        class="resize"
        [class.visible]="selectedIndex === i"
      />
    </div>
    <button (click)="prevImage()" style="background-color: black;border: none;"><mat-icon style="background-color: black;color: rgb(215, 77, 0);">keyboard_arrow_left</mat-icon></button>
    <button (click)="nextImage()" style="background-color: black;border: none;"><mat-icon style="background-color: black;color: rgb(215, 77, 0);">keyboard_arrow_right</mat-icon></button>
  </div>
</div>
